<ion-header class="ion-no-border app-inner-padding">
	<ion-grid class="ion-no-padding">
		<ion-row class="ion-no-padding">
			<ion-col size="3">
				<ion-buttons class="ion-justify-content-start">
					<ion-button class="ion-no-padding" (click)="close()">
						<ion-icon class="icon-Close"></ion-icon>
					</ion-button>
				</ion-buttons>
			</ion-col>
			<ion-col size="6">
				<ion-title size="small" class="ion-no-padding">{{ 'signature.title' | translate }}</ion-title>
			</ion-col>
			<ion-col size="3">
				<ion-buttons class="ion-justify-content-end">
					<ion-button class="ion-no-padding" (click)="save()">
						<ion-icon class="icon-Save"></ion-icon>
					</ion-button>
				</ion-buttons>
			</ion-col>
		</ion-row>
	</ion-grid>
</ion-header>
<ion-content #content>
	<canvas
		class="signature-pad-canvas"
		[ngClass]="{
			disabled: isImageUploaded
		}"
		(pointerenter)="trackSignature()"
		(pointerleave)="saveSignature()"
		(click)="trackSignature()"
		#canvas
		[width]="canvasWidth"
		[height]="canvasHeight"
	></canvas>

	<ion-grid>
		<ion-row>
			<div></div>
		</ion-row>
		<ion-row>
			<ion-col size="9">
				<ion-text>{{ 'signature.note' | translate }}</ion-text>
			</ion-col>
			<ion-col size="3">
				<ion-button (click)="clear()">{{ 'signature.clearButton' | translate }}</ion-button>
			</ion-col>
		</ion-row>
		<ion-row>
			<input type="file" accept="image/*" style="display: none;" #fileInput (change)="handleFileSelect($event)">
			<ion-button
				class="upload"
				[ngClass]="{
					solid: isImageUploaded,
					dashed: !isImageUploaded
				}"
				(click)="openGallery()"
			>
				<ion-icon class="icon-Arrow-Up"></ion-icon>
				{{
					(isImageUploaded ? 'signature.uploadButton.success' : 'signature.uploadButton.failure') | translate
				}}
				<ion-button *ngIf="isImageUploaded" class="ion-no-padding" (click)="removeUploadedPhoto($event)">
					<ion-icon class="icon-Close"></ion-icon>
				</ion-button>
			</ion-button>
		</ion-row>
	</ion-grid>
</ion-content>
<ion-footer>
	<ion-fab-button (click)="scrollToBottom()" *ngIf="isOrientationLandscape">
		<ion-icon class="icon-Arrow-Down"></ion-icon>
	</ion-fab-button>
</ion-footer>
